// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const SHRUNK_NODE_HEIGHT = 65;
export const EXPANDED_NODE_HEIGHT = 470;
